module.exports = __webpack_public_path__ + "static/media/discord.f5669fb9.svg";